import axios from "axios";
import { clearAuthAndRedirect } from "./auth";

const baseURL = process.env.REACT_APP_API || "";

const apiClient = axios.create({
  baseURL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function shouldForceLogout(err) {
  const status = err.response?.status;
  const msg = err.response?.data?.message;
  if (status === 401) return true;
  if (status === 400 && typeof msg === "string" && msg.toLowerCase().includes("invalid token")) {
    return true;
  }
  return false;
}

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (shouldForceLogout(err)) clearAuthAndRedirect();
    return Promise.reject(err);
  }
);

export default apiClient;
